
	import {
		Vue,
		Component,
		Emit
	} from "vue-property-decorator";
	import empty from "../../components/empty.vue";
	import listRequest from '../../js/listRequest.js';
	import formHelper from '../../js/teachingMaterial/teaching.material.center.helper';
	@Component({
		components: {
			empty
		},
	})
	//export default class "组件名" extends Vue
	export default class teachingCenter extends Vue {
		query:any = {
		    subject: "",
		    period: "",
			teachingName:""
		};
		pager: any = {
			default: {
				pagesize: listRequest.pagesize,
				pagenum: 1,
				total: 0,
				rows: [
					{
						cell:{
							id:"11111",
							name:"Python基础",
							introduction:"将Python编程与学科数学结合起来，将小学数学知识与代码编程相结合，促进学科之间的融合。一方面，提升学生的数学理解能力，另一方面提升学的编程能力、逻辑思维能力。另一方面提升学的编程能力、逻辑思维能力",
							relativeIamge:""
						}
					}
				]
			}
		};
		form: any = formHelper.copyNewForm(formHelper.form);
		formRules: any = formHelper.formRules;
		pageData:any={
			periodList:[{
				id:"1111",
				value:"1",
				name:"小学"
			},
			{
				id:"2222",
				value:"2",
				name:"初中"
			},
			{
				id:"3333",
				value:"3",
				name:"高中"
			}],
			subjectList:[{
				id:"1111",
				value:"1",
				name:"语文"
			},
			{
				id:"2222",
				value:"2",
				name:"数学"
			},
			{
				id:"3333",
				value:"3",
				name:"地理"
			}],
		};
		currentpPage: number = 5;
		formDialogVisible:boolean =  false;
		confirmLoading: boolean =  false;
		loading:boolean = false;
		submitLoading: boolean = false;
		handleChange() {
			console.log('切换属性');
		};
		showModal() {
		    this.formDialogVisible = true;
		};
		handleOk(){
			this.confirmLoading = true;
			setTimeout(() => {
				this.formDialogVisible = false;
				this.confirmLoading = false;
			}, 2000);
		};
		handleCancel(){
			this.formDialogVisible = false;
			this.$nextTick(function(){
			   (this.$refs.formRef as any).resetFields();
			});
	
			
		};
		beforeUpload(){
		};
		onDoSaveForm(){
			var me = this;
			(this.$refs.formRef as any).validate((valid:any) => {
				if (!!valid===false) {
					console.log("error...........");
					return;
				}
				this.$confirm({
					title: '提示',
					content: '是否继续该操作',
					onOk() {
						console.log('操作成功');
					},
					onCancel() {
						console.log('Cancel');
					}
				});
			});
		};

		mounted() {

		};

		created() {
			// this.pager.default.rows.length = 9;
		};
	}
